// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"5f520b37","93":"fde23fd6","100":"e5a6ae17","193":"98e43604","237":"c155fda9","527":"d03c7339","669":"20a6149b","697":"0037cace","778":"fa3e2cda","832":"9bd3ece9","942":"40994530","989":"5f8c4adf"}[chunkId] + ".chunk.js";
};